// api/banners.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://prod.getrevibe.app/api';

// ============================================
// API Client Configuration
// ============================================
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear auth data on unauthorized
      localStorage.removeItem('authToken');
      localStorage.removeItem('userId');
      localStorage.removeItem('userData');
      localStorage.removeItem('isProfileCreated');
      window.dispatchEvent(new Event('userUpdated'));
    }
    return Promise.reject(error);
  }
);

// ============================================
// Banners API
// ============================================
export const footerBannersApi = {
  // Fetch footer banners with pagination and filtering
  getFooterBanners: async (params = {}) => {
    const defaultParams = {
      sortOrder: 'asc',
      page: 1,
      limit: 10,
      search: '',
      ...params
    };
    
    try {
      const response = await apiClient.get('/footer-banners', { params: defaultParams });
      return response.data.footerBanners || [];
    } catch (error) {
      console.error('Error fetching footer banners:', error);
      throw error;
    }
  },
  
  // Get single banner by ID
  getBannerById: async (id) => {
    try {
      const response = await apiClient.get(`/footer-banners/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching banner ${id}:`, error);
      throw error;
    }
  },
  
  // Get image URL helper
  getImageUrl: (imgPath) => {
    if (!imgPath) return 'https://via.placeholder.com/400x400?text=No+Image';
    
    if (imgPath.startsWith('http')) {
      return imgPath;
    }
    
    // Remove /api from base URL if present
    const baseUrl = API_URL?.replace('/api', '') || 'https://prod.getrevibe.app';
    return `${baseUrl}${imgPath}`;
  }
};

// Export the apiClient as well for other API files if needed
export { apiClient };

// Default export
export default footerBannersApi;